<div class="video-player-wrapper">
	@if (raceStreamDisabled()) {
		<div class="video-error h-full justify-center">
			<div class="video-error-icon">
				<i class="bi bi-exclamation-circle text-3xl"></i>
			</div>
			<p class="video-error-text">Race stream has been disabled by admin.</p>
		</div>
	} @else if (showStreamUnavailableMessage()) {
		<div class="video-error h-full justify-center">
			<div class="video-retry-icon">
				<i class="bi bi-arrow-repeat text-3xl"></i>
			</div>
			<p class="video-error-text">
				@if (isRetryingUrl()) {
					Stream will start automatically once available
				} @else {
					Stream is currently unavailable
				}
			</p>
		</div>
	} @else if (
		streamData &&
		!isTwitchPlayer &&
		streamPlayerConfig &&
		streamPlayerConfig?.sources?.[0]?.src
	) {
		<vbrick-player
			[config]="streamPlayerConfig?.playerConfig"
			[playbackOptions]="streamPlayerConfig?.sources"
			[isLive]="streamPlayerConfig?.isLive"
			[autoPlay]="streamPlayerConfig?.autoPlay"
			[translations]="PLAYER_TRANSLATIONS"
			[disableUserPreferenceStore]="true"
			[playbackUnavailableMsgTemplate]="playbackUnavailableTemplate"
			(onComplete)="onPlaybackEnded()"
			(onPlayerReady)="onPlayerReady($event.vgAPI)"
			(onPlaybackError)="onPlaybackError()"
		>
		</vbrick-player>
	} @else if (isTwitchPlayer) {
		<div [id]="twitchContainerId" class="w-full h-full">
			@if (!twitchPlayerLoaded) {
				<div
					class="race-not-happening-place-holder d-flex align-items-center justify-content-center"
				>
					<div class="text-center m-0" style="color: white" role="alert">
						Twitch Player is loading...
					</div>
				</div>
			}
		</div>
	}
	@if (streamData?.carNumber && showTelemetry()) {
		<div
			class="telemetry-toggle text-sm absolute top-0 right-0 p-2 m-2 bg-surface rounded-xs"
			[style.opacity]="0.5"
			[style.zIndex]="99"
		>
			<button (click)="toggleTelemetry()">{{ showTelemetry() ? 'Hide' : 'Show' }} Telemetry</button>
		</div>
	}
	@if (
		visibilitiesService.controlVisibilities().showTelemetry &&
		showTelemetry() &&
		streamData.carNumber
	) {
		<div
			class="telemetry-wrapper absolute left-0 bottom-0 bg-surface p-2 rounded-xs m-2"
			[style.opacity]="0.5"
		>
			<strong class="text-on-surface text-sm">
				{{ formatSpeed(telemetry()?.speed) }}
			</strong>
			<span class="px-2">|</span>
			<strong class="text-on-surface text-sm"> {{ telemetry()?.gear }} gear </strong>
			<span class="px-2">|</span>
			<strong class="text-on-surface text-sm">
				@if (telemetry()?.engine_rpm > 1) {
					{{ telemetry()?.engine_rpm }}
				} @else {
					@if (telemetry()?.engine_rpm > 0.2) {
						<span class="rpm-low mr-1">⦿</span>
					} @else {
						<span class="mr-1">-</span>
					}
					@if (telemetry()?.engine_rpm > 0.4) {
						<span class="rpm-low mr-1">⦿</span>
					} @else {
						<span class="mr-1">-</span>
					}
					@if (telemetry()?.engine_rpm > 0.6) {
						<span class="rpm-med mr-1">⦿</span>
					} @else {
						<span class="mr-1">-</span>
					}
					@if (telemetry()?.engine_rpm > 0.8) {
						<span class="rpm-med mr-1">⦿</span>
					} @else {
						<span class="mr-1">-</span>
					}
					@if (telemetry()?.engine_rpm === 1) {
						<span class="rpm-high mr-1">⦿</span>
					} @else {
						<span class="mr-1">-</span>
					}
				}
				rpm
			</strong>
			<strong class="text-on-surface text-sm">
				@if (telemetry()?.regen === 1) {
					<span class="flex items-center">
						Regen:
						<i class="bi bi-lightning-charge-fill"></i>
					</span>
				}
			</strong>
		</div>
		<div
			class="telemetry-wrapper absolute right-0 bottom-0 flex flex-col bg-surface p-2 rounded-xs m-2 text-sm"
			[style.opacity]="0.5"
		>
			<div class="flex flex-row">
				<vb-lxp-bar-gauge
					label="B"
					[value]="telemetry()?.brake_percentage_front"
					color="#ff0000"
					direction="right"
					unit="%"
				></vb-lxp-bar-gauge>
				<vb-lxp-bar-gauge
					label="T"
					[value]="telemetry()?.throttle_percentage"
					color="#00ff00"
					direction="right"
					unit="%"
				></vb-lxp-bar-gauge>
				<vb-lxp-bar-gauge
					label="E"
					[value]="telemetry()?.energy_remaining"
					color="#ffff00"
					direction="right"
					unit="%"
				></vb-lxp-bar-gauge>
			</div>
		</div>
	}
</div>

<ng-template #playbackUnavailableTemplate>
	<div class="video-error">
		<div class="video-error-icon">
			<i class="bi bi-exclamation-circle text-3xl"></i>
		</div>
		<p class="video-error-text">Stream temporarily unavailable. Please try again.</p>
	</div>
</ng-template>
